import {
    DeleteOutlined,
    EditOutlined,
    QuestionCircleOutlined,
} from "@ant-design/icons";
import {
    Button,
    Form,
    Input,
    Modal,
    notification,
    Popconfirm,
    Skeleton,
    theme,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomTable from "../common/Table";
import { TeamMangementContext } from ".";

function Team() {
    const { token } = theme.useToken();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [formData, setFormData] = useState({ staff_id, page: 0, limit: 10 });
    const [teamData, setTeamData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [modalTitle, setModalTitle] = useState("Add Team");
    const [form] = Form.useForm();
    const { teamFormVisible, setTeamFormVisible } =
        useContext(TeamMangementContext);

    const {
        status: teamStatus,
        data: teamRes,
        refetch: getTeam,
    } = useQuery(
        "team",
        async () => {
            return await HTTP("/teams/getTeams", { ...formData });
        },
        { enabled: false },
    );

    const columns = [
        { title: "Name", dataIndex: "name", key: "name", sorter: () => {} },
        {
            title: "Action",
            render: (text, record) => {
                return (
                    <div className="flex gap-2">
                        <Popconfirm
                            title="Are you sure want to delete?"
                            onConfirm={() => deleteTeam(record.id)}
                            icon={
                                <QuestionCircleOutlined
                                    style={{
                                        color: token.colorError,
                                    }}
                                />
                            }
                        >
                            <Button
                                type="text"
                                size="small"
                                icon={
                                    <DeleteOutlined
                                        style={{ color: token.colorError }}
                                    />
                                }
                                style={{
                                    // color: "#e05c7a",
                                    background: "rgba(224,92,122,0.08)",
                                    border: "1px solid rgba(224,92,122,0.2)",
                                    borderRadius: 7,
                                    width: 30,
                                    height: 30,
                                }}
                            />
                        </Popconfirm>
                        <Button
                            type="text"
                            size="small"
                            icon={
                                <EditOutlined
                                    style={{ color: token.colorPrimary }}
                                    id={record.id}
                                    onClick={() => openEditForm(record)}
                                />
                            }
                            style={{
                                // color: "#e05c7a",
                                background: token.colorBgElevated,
                                border: `1px solid ${token.colorPrimaryDark}`,
                                borderRadius: 7,
                                width: 30,
                                height: 30,
                            }}
                        />
                    </div>
                );
            },
        },
    ];

    async function deleteTeam(id) {
        const { success, message } = await HTTP("/teams/deleteTeam", {
            staff_id,
            id,
        });
        let type = "error";
        if (success) {
            type = "info";
        }
        notification[type]({ message });
        getTeam();
    }

    function openEditForm(record) {
        form.setFieldsValue({ name: record.name, id: record.id });
        setModalTitle("Edit");
        setTeamFormVisible(true);
    }

    async function handleSubmit(values) {
        let url = "/teams/addTeam";
        if (values.id) {
            url = "/teams/updateTeam";
        }

        const { success, message } = await HTTP(url, { staff_id, ...values });
        let type = "error";
        if (success) {
            type = "info";
        }
        notification[type]({ message });
        closeForm();
        getTeam();
    }

    function closeForm() {
        setTeamFormVisible(false);
        setModalTitle("Add Team");
        form.resetFields();
    }

    useEffect(() => {
        getTeam();
    }, []);

    useEffect(() => {
        getTeam();
    }, [formData]);

    useEffect(() => {
        if (teamStatus === "success") {
            const { data, total } = teamRes;
            setTeamData(data);
            setTotalRecords(total);
        }
    }, [teamStatus, teamRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        }
        setFormData({ ...formData, ...others });
    }

    return (
        <>
            {teamStatus !== "loading" && teamStatus !== "idle" ? (
                <CustomTable
                    columns={columns}
                    tableData={teamData}
                    noOfrecords={totalRecords}
                    handleTableChange={handleTableChange}
                    rowKey="id"
                    isScroll
                />
            ) : (
                <Skeleton active title={false} paragraph={{ rows: 10 }} />
            )}

            <Modal
                open={teamFormVisible}
                title={modalTitle}
                footer=""
                destroyOnHidden
                onCancel={closeForm}
            >
                <Form form={form} onFinish={handleSubmit}>
                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[
                            { required: true, message: "Please Add Name..!" },
                        ]}
                    >
                        <Input id="name" />
                    </Form.Item>
                    <Form.Item name="id" className="hidden">
                        <Input id="id" disabled />
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}
export default Team;
